import {useEffect, useState} from "react";

export default function useBuffer(dataToWatch, timezone) {
    const [bufferSize, setBufferSize] = useState(4);

    useEffect(() => {
        setBufferSize(bufferSize * 1.001);
    }, [dataToWatch, timezone]);

    return {bufferSize};
}